import { render, staticRenderFns } from "./CrudView.vue?vue&type=template&id=73e35827&scoped=true"
import script from "./CrudView.vue?vue&type=script&lang=js"
export * from "./CrudView.vue?vue&type=script&lang=js"
import style0 from "./CrudView.vue?vue&type=style&index=0&id=73e35827&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e35827",
  null
  
)

export default component.exports